import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  props: ['myItemData'],
  computed: {
  },
  methods: {
    pageSizeChange () {
      this.$emit('pageSizeChange')
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/components/insurance-record-child.js